const brandArray = [
  {
    logo: '/images/pages/home/brands/logos/pizzeria-bianco.png',
    background: '/images/pages/home/brands/backgrounds/pizzaria_bianco',
    alt: 'Pizzeria Bianco',
    increaseSize: true,
    url: 'https://rowdtla.com/collective/pizzeria-bianco'
  },
  {
    logo: '/images/pages/home/brands/logos/arcade-logo.png',
    background: '/images/pages/home/brands/backgrounds/arcade',
    alt: 'Arcade',
    increaseSize: true,
    url: 'https://rowdtla.com/collective/arcade'
  },
  {
    logo: '/images/pages/home/brands/logos/bodega.svg',
    background: '/images/pages/home/brands/backgrounds/bodega',
    alt: 'Bodega',
    url: 'https://rowdtla.com/collective/bodega'
  },
  {
    logo: '/images/pages/home/brands/logos/hayato.svg',
    background: '/images/pages/home/brands/backgrounds/hayato',
    alt: 'Hayato',
    url: 'https://rowdtla.com/collective/hayato'
  },
  {
    logo: '/images/pages/home/brands/logos/shopify.svg',
    background: '/images/pages/home/brands/backgrounds/shopify',
    alt: 'Shopify',
    url: 'https://rowdtla.com/collective/shopify'
  },
  {
    logo: '/images/pages/home/brands/logos/gget.svg',
    background: '/images/pages/home/brands/backgrounds/gget',
    alt: 'gget',
    url: 'https://rowdtla.com/collective/go-get-em-tiger'
  },
  {
    logo: '/images/pages/home/brands/logos/joybird.png',
    background: '/images/pages/home/brands/backgrounds/joybird',
    alt: 'joybird',
    joybirdLogo: true,
    increaseSize: true,
    url: 'https://rowdtla.com/collective/joybird'
  },
  {
    logo: '/images/pages/home/brands/logos/the_things_we_do.svg',
    background: '/images/pages/home/brands/backgrounds/the_things_we_do',
    alt: 'the things we do',
    url: 'https://rowdtla.com/collective/the-things-we-do'
  },
  {
    logo: '/images/pages/home/brands/logos/smorgasburg.svg',
    background: '/images/pages/home/brands/backgrounds/smorgasburg',
    alt: 'smorgasburg',
    url: 'https://rowdtla.com/collective/smorgasburg'
  }
];

const keyFacts = [
  'Retail, Office, and Events',
  'Turn-key retail spaces available with flexible occupancy',
  'Storage available',
  'Be a part of a growing district',
  'Parking: state of the art, safe, and secure structure for all of your customers. Validation available.',
  'Unparalleled merchandising mix unique to LA',
  'World class dining includes 2 Michelin-starred chefs',
  'Separately metered utilities',
  'Master C.U.P. for liquor licenses',
  'Prominent eyebrow signage and multiple directories throughout the district',
  'Grease shaft and interceptor available for restaurant units',
  'Private event spaces'
];

const pressLogos = [
  {
    logo: '/images/pages/home/press/goop.svg',
    alt: 'GOOP',
    href: 'https://goop.com/place/california/los-angeles/downtown-shops/row-dtla/'
  },
  {
    logo: '/images/pages/home/press/la_times.svg',
    alt: 'LA Times',
    href: 'https://www.latimes.com/home/la-hm-four-hours-row-dtla-20190607-story.html'
  },
  {
    logo: '/images/pages/home/press/la_mag.svg',
    alt: 'LA Magazine',
    href: 'https://www.lamag.com/sponsored/experience-a-taste-of-everything-row-dtla/'
  },
  {
    logo: '/images/pages/home/press/la_business_journal.svg',
    alt: 'LA Business Journal',
    href:
      'https://labusinessjournal.com/news/2019/jun/20/ghost-management-group-signs-115k-sf-arts-district/'
  },
  {
    logo: '/images/pages/home/press/monocle.svg',
    alt: 'Monocle',
    href: 'https://monocle.com/magazine/issues/123/top-of-the-shops/'
  },
  {
    logo: '/images/pages/home/press/blackbook.svg',
    alt: 'Black Book',
    href:
      'https://bbook.com/news/downtown-los-angeles-renaissance-our-favorite-stops-at-the-row-dtla/'
  },
  {
    logo: '/images/pages/home/press/urbanize_la.svg',
    alt: 'Urbanize LA',
    href: 'https://rowdtla.com/this-weeks-leases-zappos-takes-space-at-row-dtla'
  },
  {
    logo: '/images/pages/home/press/food_and_wine.svg',
    alt: 'Food & Wine',
    href: 'https://www.foodandwine.com/news/row-dtla-opens-los-angeles'
  },
  {
    logo: '/images/pages/home/press/cn_traveler.svg',
    alt: 'CN Traveler',
    href: 'https://www.cntraveler.com/shops/los-angeles/row-dtla'
  },
  {
    logo: '/images/pages/home/press/jetsetter.svg',
    alt: 'Jetsetter',
    href: 'https://www.jetsetter.com/magazine/youre-not-a-tourist-los-angeles/#row-dtla'
  },
  {
    logo: '/images/pages/home/press/thrillist.svg',
    alt: 'Thrillist',
    href: 'https://www.thrillist.com/travel/nation/best-attractions-usa-2019'
  },
  {
    logo: '/images/pages/home/press/bisnow.svg',
    alt: 'Bisnow',
    href: 'https://www.bisnow.com/los-angeles/news/deal-sheet/the-la-deal-sheet-98504'
  },
  {
    logo: '/images/pages/home/press/mann_publications.svg',
    alt: 'Mann Publications',
    href: 'http://www.mannpublications.com/mannreportresidential/2019/05/08/la-lifestyles-row-dtla/'
  },
  {
    logo: '/images/pages/home/press/eat_drink_la.svg',
    alt: 'Eat Drink LA',
    href: 'https://www.eatdrinkla.com/food-meets-fashion-at-row-dtla/'
  },
  {
    logo: '/images/pages/home/press/bloomberg.svg',
    alt: 'Bloomberg',
    href:
      'https://www.bnnbloomberg.ca/shopify-to-open-first-bricks-and-mortar-location-in-l-a-1.1114516'
  }
];

export { brandArray, keyFacts, pressLogos };
